import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6aa8c3a40a1ed800141e6a2e_1789449200836_d4ef032d/nongki/src/app/sign-up-login-screen/components/AuthPageClient.tsx");
